import { useCallback, useRef, useState } from "react";
import { listProductPackages } from "../../../components/productPackages/functions";

export function useProductPackagesSearch(user) {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const lastFiltersRef = useRef({});
  const requestIdRef = useRef(0);

  const search = useCallback(
    async (filters = {}) => {
      if (!user?.token) {
        return;
      }

      const requestId = ++requestIdRef.current;
      const normalizedFilters = {
        ...(filters.q ? { q: filters.q } : {}),
        ...(filters.isActive !== undefined ? { isActive: filters.isActive } : {}),
      };
      lastFiltersRef.current = normalizedFilters;
      setLoading(true);
      setError(null);

      const data = await listProductPackages(user.token, normalizedFilters);

      if (requestId !== requestIdRef.current) {
        return;
      }

      if (data?.type === "error") {
        setError(data);
        setPackages([]);
      } else if (data?.type === "success") {
        setPackages(data.data ?? []);
      } else {
        setPackages([]);
      }

      setLoading(false);
    },
    [user?.token]
  );

  const refresh = useCallback(() => search(lastFiltersRef.current), [search]);

  return { packages, loading, error, search, refresh };
}
